import React from 'react';
import { clsx } from 'clsx';
import { Check } from 'lucide-react';
import { COLOR_LABELS, COLOR_NAMES, ColorName, colorClasses, colorOrDefault } from '@/utils/colors';

interface ColorPickerProps {
  value: string;
  onChange: (color: ColorName) => void;
  size?: 'sm' | 'md';
  disabled?: boolean;
}

/**
 * Seletor da paleta de cores de quadros/colunas. Só oferece nomes de `COLOR_NAMES` — uma cor
 * livre não sobreviveria ao build do Tailwind (ver utils/colors.ts).
 */
export const ColorPicker: React.FC<ColorPickerProps> = ({ value, onChange, size = 'md', disabled }) => {
  const current = colorOrDefault(value);
  return (
    <div className="flex flex-wrap gap-1.5" role="radiogroup">
      {COLOR_NAMES.map((c) => {
        const selected = c === current;
        return (
          <button
            key={c}
            type="button"
            role="radio"
            aria-checked={selected}
            title={COLOR_LABELS[c]}
            disabled={disabled}
            onClick={() => onChange(c)}
            className={clsx(
              'rounded-full flex items-center justify-center transition-transform hover:scale-110 disabled:opacity-50 disabled:hover:scale-100',
              size === 'sm' ? 'w-5 h-5' : 'w-7 h-7',
              colorClasses(c).swatch,
              selected && 'ring-2 ring-offset-2',
              selected && colorClasses(c).ring,
            )}
          >
            {selected && <Check size={size === 'sm' ? 10 : 14} className="text-white" />}
          </button>
        );
      })}
    </div>
  );
};
